module.exports = __webpack_public_path__ + "images/onboarding-devices-cropped.11fffdcc3edd069f970db633c007f3c6.png";